module.exports = __webpack_public_path__ + "static/CircularStd-Bold-2c34e4eae7a25247438484f54389a450.ttf";